/* MoleAway Landing Page — vanilla JS, no dependencies */
(function () {
  'use strict';

  /* ── Zuverlässiger Init-Einstieg ───────────────────────────────────────── */
  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  function init() {
    initBundleCards();
    initStickyBar();
    initSwiper();
    initFaq();
    initRatingBars();
  }

  /* ── Bundle-Karten ──────────────────────────────────────────────────────
     Wenn eine Karte angeklickt wird:
     1. Visuellen Selected-State setzen
     2. Das hidden <input name="id"> in ALLEN .ma-purchase-form aktualisieren
     3. Sticky Bar aktualisieren
  ───────────────────────────────────────────────────────────────────────── */
  function initBundleCards() {
    document.querySelectorAll('.ma-bundle-selector').forEach(function (selector) {
      var cards = selector.querySelectorAll('.ma-variant-card');

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          // Visual select
          cards.forEach(function (c) { c.classList.remove('selected'); });
          card.classList.add('selected');

          // Update ALL purchase forms on page (hero + final-cta + sticky)
          var variantId = card.getAttribute('data-variant-id') || '';
          document.querySelectorAll('.ma-selected-variant-id').forEach(function (inp) {
            inp.value = variantId;
          });

          updateStickyBar(card);
        });
      });

      // Pre-select Standard-Pack (data-default="true") or first card
      var defaultCard = selector.querySelector('[data-default="true"]') || cards[0];
      if (defaultCard) defaultCard.click();
    });
  }

  /* ── Sticky Bar (Mobile) ────────────────────────────────────────────────── */
  var stickyBar = null;

  function initStickyBar() {
    stickyBar = document.querySelector('.ma-sticky-bar');
    var hero = document.querySelector('.ma-section--hero');
    if (!stickyBar || !hero) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        stickyBar.classList.toggle('visible', !e.isIntersecting);
      });
    });
    io.observe(hero);
  }

  function updateStickyBar(card) {
    if (!stickyBar) return;
    var packEl  = stickyBar.querySelector('.ma-sticky-bar__pack');
    var priceEl = stickyBar.querySelector('.ma-sticky-bar__price');
    if (packEl)  packEl.textContent  = card.getAttribute('data-pack-name') || '';
    if (priceEl) priceEl.textContent = card.getAttribute('data-price') || '';
  }

  /* ── Swiper ─────────────────────────────────────────────────────────────── */
  function initSwiper() {
    document.querySelectorAll('.ma-swiper__outer').forEach(function (outer) {
      var track  = outer.querySelector('.ma-swiper__track');
      var slides = track ? track.querySelectorAll('.ma-swiper__slide') : [];
      if (!track || slides.length === 0) return;

      var swiper   = outer.closest('.ma-swiper');
      var dotsWrap = swiper ? swiper.querySelector('.ma-swiper__dots') : null;
      var prevBtn  = swiper ? swiper.querySelector('.ma-swiper__btn--prev') : null;
      var nextBtn  = swiper ? swiper.querySelector('.ma-swiper__btn--next') : null;

      var current = 0;
      var dots    = [];

      // Dots erstellen
      if (dotsWrap) {
        for (var i = 0; i < slides.length; i++) {
          (function (idx) {
            var dot = document.createElement('span');
            dot.className = 'ma-swiper__dot';
            dot.addEventListener('click', function () { goTo(idx); });
            dotsWrap.appendChild(dot);
            dots.push(dot);
          })(i);
        }
      }

      function goTo(idx) {
        current = ((idx % slides.length) + slides.length) % slides.length;
        // Pixel-basiert: translateX(-(current × sichtbare Breite))
        track.style.transform = 'translateX(-' + (current * outer.offsetWidth) + 'px)';
        dots.forEach(function (d, i) {
          d.className = 'ma-swiper__dot' + (i === current ? ' active' : '');
        });
      }

      goTo(0); // Initialisierung

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

      // Touch-Swipe
      var touchStartX = 0;
      outer.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      outer.addEventListener('touchend', function (e) {
        var dx = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(dx) > 40) goTo(current + (dx > 0 ? 1 : -1));
      }, { passive: true });

      // Keyboard-Navigation
      outer.setAttribute('tabindex', '0');
      outer.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  goTo(current - 1);
        if (e.key === 'ArrowRight') goTo(current + 1);
      });

      // Resize: Pixel-Position neu berechnen
      window.addEventListener('resize', function () { goTo(current); }, { passive: true });

      // Autoplay
      if (outer.getAttribute('data-autoplay') === 'true') {
        var timer = setInterval(function () { goTo(current + 1); }, 5000);
        outer.addEventListener('mouseenter', function () { clearInterval(timer); });
        outer.addEventListener('mouseleave', function () {
          timer = setInterval(function () { goTo(current + 1); }, 5000);
        });
      }
    });
  }

  /* ── FAQ-Akkordeon ──────────────────────────────────────────────────────── */
  function initFaq() {
    var items = document.querySelectorAll('.ma-faq__item');
    items.forEach(function (item) {
      var question = item.querySelector('.ma-faq__question');
      var answer   = item.querySelector('.ma-faq__answer');
      if (!question || !answer) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        // Alle schließen
        items.forEach(function (i) {
          i.classList.remove('open');
          var a = i.querySelector('.ma-faq__answer');
          if (a) a.classList.remove('open');
        });
        // Geklicktes öffnen (wenn es vorher zu war)
        if (!isOpen) {
          item.classList.add('open');
          answer.classList.add('open');
        }
      });
    });
  }

  /* ── Bewertungs-Balken (animate on scroll) ──────────────────────────────── */
  function initRatingBars() {
    var bars = document.querySelectorAll('.ma-dist-bar');
    if (!bars.length || !window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.width = e.target.getAttribute('data-width') || '0%';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    bars.forEach(function (bar) {
      bar.setAttribute('data-width', bar.style.width);
      bar.style.width = '0%';
      io.observe(bar);
    });
  }

})();
